/* SETTINGS */
import routesSettings from '~/pages/settings/settingsRoutes';

/* User gestion  */
const PageLogin = () => import('~/pages/auth/PageLogin.vue').then((m) => m.default || m);
const PageNoTenant = () => import('~/pages/errors/PageNoTenant.vue').then((m) => m.default || m);
const PageNotFound = () => import('~/pages/errors/Page404.vue').then((m) => m.default || m);
const PageForbidden = () => import('~/pages/errors/Page403.vue').then((m) => m.default || m);
const PageForgotPassword = () => import('~/pages/auth/PageForgotPassword.vue').then((m) => m.default || m);
const PageForgotPasswordConfirmation = () => import('~/pages/auth/PageForgotPasswordConfirmation.vue').then((m) => m.default || m);
const PageResetPassword = () => import('~/pages/auth/PageResetPassword.vue').then((m) => m.default || m);
const PageHome = () => import('~/pages/PageHome.vue').then((m) => m.default || m);

/* Dashboard */
const PageDashboardId = () => import('~/pages/navigation/bottom/dashboard/PageDashboardId.vue').then((m) => m.default || m);
const MachineDetailPage = () => import('~/pages/navigation/bottom/dashboard/components/machine-detail/MachineDetailPage.vue').then((m) => m.default || m);
const PageEvent = () => import('~/pages/navigation/bottom/events/PageEvent.vue').then((m) => m.default || m);
const EventCategorization = () => import('~/pages/navigation/bottom/events/EventCategorization.vue').then((m) => m.default || m);

/* Production */
const PlanningMain = () => import('~/pages/navigation/bottom/production/components/planning/PlanningMain.vue').then((m) => m.default || m);
const PlanningToPlan = () => import('~/pages/navigation/bottom/production/components/planning/PlanningToPlan.vue').then((m) => m.default || m);
const PlanningLaunched = () => import('~/pages/navigation/bottom/production/components/planning/PlanningLaunched.vue').then((m) => m.default || m);
const PlanningDone = () => import('~/pages/navigation/bottom/production/components/planning/PlanningDone.vue').then((m) => m.default || m);

const planningModuleTabs = [
  {
    label: 'planning.tabs.planning',
    to: '/planning',
  },
  {
    label: 'planning.tabs.toPlan',
    to: '/planning-to-plan',
  },
  {
    label: 'planning.tabs.launched',
    to: '/planning-launched',
  },
  {
    label: 'planning.tabs.done',
    to: '/planning-done',
  },
];

const PageCharts = () => import('~/pages/PageCharts.vue').then((m) => m.default || m);
const PageIcons = () => import('~/pages/PageIcons.vue').then((m) => m.default || m);

export default [
  {
    path: '/',
    name: 'home',
    component: PageHome,
    meta: { layout: 'FocusLayout' },
  },
  {
    path: '/login',
    name: 'login',
    component: PageLogin,
    meta: { isAnonymous: true, layout: 'FocusLayout' },
  },
  {
    path: '/password/forgot',
    name: 'password.forgot',
    component: PageForgotPassword,
    meta: { isAnonymous: true, layout: 'FocusLayout' },
  },
  {
    path: '/password/forgotConfirmation',
    name: 'password.forgotConfirmation',
    component: PageForgotPasswordConfirmation,
    meta: { isAnonymous: true, layout: 'FocusLayout' },
  },
  {
    path: '/password/resetPassword/',
    name: 'password.resetPassword',
    component: PageResetPassword,
    meta: { isAnonymous: true, layout: 'FocusLayout' },
  },
  {
    path: '/notenant',
    name: 'notenant',
    component: PageNoTenant,
    meta: { isAnonymous: true, layout: 'FocusLayout' },
  },
  ...routesSettings,
  {
    path: '/planning',
    component: PlanningMain,
    name: 'planning.main',
    meta: {
      moduleTabs: planningModuleTabs,
      mixPanel: 'Planning Viewed',
      resource: 'Planning',
    },
  },
  {
    path: '/planning-to-plan',
    name: 'planning.toPlan',
    component: PlanningToPlan,
    meta: {
      breadcrumb: 'job.toPlan',
      moduleTabs: planningModuleTabs,
      mixPanel: 'Planning Viewed',
      resource: 'Planning',
    },
  },
  {
    path: '/planning-launched',
    name: 'planning.launched',
    component: PlanningLaunched,
    meta: {
      breadcrumb: 'job.launched',
      moduleTabs: planningModuleTabs,
      mixPanel: 'Planning Viewed',
      resource: 'Planning',
    },
  },
  {
    path: '/planning-done',
    name: 'planning.done',
    component: PlanningDone,
    meta: {
      breadcrumb: 'job.done',
      moduleTabs: planningModuleTabs,
      mixPanel: 'Planning Viewed',
      resource: 'Planning',
    },
  },
  {
    // Mandatory id: `/dashboard` alone falls through to the `notFound` catch-all
    path: '/dashboard/:value',
    name: 'dashboardId',
    component: PageDashboardId,
    meta: {
      mixPanel: 'Dashboard Viewed',
    },
  },
  {
    // Full-page machine detail view (KP-18701). No meta.layout → DefaultLayout
    // (app shell = full page). Reached from the indicators table "Détail" action.
    path: '/machine/:id',
    name: 'machineDetail',
    component: MachineDetailPage,
    meta: {
      mixPanel: 'Machine Detail Viewed',
    },
  },
  {
    path: '/event',
    name: 'event',
    component: PageEvent,
    meta: {
      mixPanel: 'Timeline Viewed',
    },
    children: [
      {
        path: ':id',
        name: 'eventId',
        component: PageEvent,
      },
    ],
  },
  {
    path: '/categorization',
    name: 'categorization',
    component: EventCategorization,
    meta: {
      mixPanel: 'Categorization Viewed',
    },
  },
  {
    path: '/charts',
    name: 'charts',
    component: PageCharts,
  },
  {
    path: '/icons',
    name: 'icons',
    component: PageIcons,
  },
  {
    path: '/forbidden',
    name: 'forbidden',
    component: PageForbidden,
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'notFound',
    component: PageNotFound,
  },
];
